export default __webpack_public_path__ + "static/media/cityIcon.5fe67b91.svg";